import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Import the arrow icon
import { useAuth } from "../components/TokenHandler";
import ObservationModal from "../components/ObservationModal";

const modalStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1250,
    maxHeight: "85vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    overflowY: "auto",
    borderRadius: "0px",
};

const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    bgcolor: "#00A7A0",
    color: "white",
    padding: "16px 24px",
};

const buttonContainerStyle = {
    display: "flex",
    justifyContent: "flex-end",
    padding: "16px 24px",
};

const tableCellStyle = {
    fontWeight: 600,
    backgroundColor: "#f5f5f5",
    color: "#333",
};

const FullCheckInHistoryModal = ({ open, onClose, onBack, checkInId, building, onAddToThread }) => {
    const [checkInHistory, setCheckInHistory] = useState(null);
    const { keycloak: kc } = useAuth();
    const [isObservationModalOpen, setIsObservationModalOpen] = useState(false);

    const openObservationModal = () => setIsObservationModalOpen(true);
    const closeObservationModal = () => {
        setIsObservationModalOpen(false);
        fetchCheckInHistory(); // Refresh check-in history after closing
    };
    const fetchCheckInHistory = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/get_checkin2?id=${checkInId}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${kc.token}`,
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.json();

                // Sort the thread in descending order by date (latest first)
                data.thread.sort((a, b) => new Date(b.date) - new Date(a.date));

                setCheckInHistory(data);
               // console.log(data);
            } else {
                console.error("Failed to fetch full check-in history");
            }
        } catch (error) {
            console.error("Error fetching full check-in history:", error);
        }
    };

    useEffect(() => {


        if (open && checkInId) {
            fetchCheckInHistory();
        }
    }, [open, checkInId]);




    return (
        <>
            {/* Full Check-In History Modal */}
            {!isObservationModalOpen && (
                <Modal open={open} onClose={onClose} aria-labelledby="modal-title">
                    <Box sx={modalStyle}>
                        {/* Header Section */}
                        <Box sx={headerStyle}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <IconButton onClick={onBack}  sx={{ color: "white" }} aria-label="Back">
                                    <ArrowBackIcon />
                                </IconButton>
                                <Typography id="modal-title" variant="h6" component="h2">
                                    {checkInHistory ? checkInHistory.subject : "Full Check-In History"}
                                </Typography>


                            </Box>
                            <IconButton onClick={onClose} sx={{ color: "white" }} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        {/* Button Section */}
                        <Box sx={buttonContainerStyle}>
                            <Button
                                variant="contained"
                                variant="contained"
                                sx={{ backgroundColor: "#2c6d91", "&:hover": { backgroundColor: "#1f4f6d" } }}
                                onClick={openObservationModal}
                            >
                                Add to Thread
                            </Button>
                        </Box>

                        {/* Table Section */}
                        {checkInHistory ? (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={tableCellStyle}>Status</TableCell>
                                        <TableCell sx={tableCellStyle}>Creator</TableCell>
                                        <TableCell sx={tableCellStyle}>Communication Method</TableCell>
                                        <TableCell sx={tableCellStyle}>Spoke with</TableCell>
                                        <TableCell sx={tableCellStyle}>Notes</TableCell>

                                        <TableCell sx={tableCellStyle}>Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {checkInHistory.thread.map((entry, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                <Box
                                                    sx={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        padding: "2px 8px",
                                                        borderRadius: "12px",
                                                        fontWeight: "bold",
                                                        fontSize: "0.875rem",
                                                        backgroundColor: entry.status.toLowerCase().startsWith("held and attended")
                                                            ? "#DFF2BF" // Light green for success
                                                            : ["not scheduled", "scheduled", "scheduled - corp"].includes(entry.status.toLowerCase())
                                                                ? "#D9EAF7" // Light blue for in progress
                                                                : entry.status.toLowerCase() === "customer no show"
                                                                    ? "#FFBABA" // Light red for error
                                                                    : "#EAEAEA", // Default grey for other statuses
                                                        color: entry.status.toLowerCase().startsWith("held and attended")
                                                            ? "#4F8A10" // Dark green text
                                                            : ["not scheduled", "scheduled", "scheduled - corp"].includes(entry.status.toLowerCase())
                                                                ? "#1A5F85" // Dark blue text
                                                                : entry.status.toLowerCase() === "customer no show"
                                                                    ? "#D8000C" // Dark red text
                                                                    : "#6C757D", // Default grey text
                                                    }}
                                                >
                                                    {entry.status.toLowerCase().startsWith("held and attended") && "✅"}
                                                    {["not scheduled", "scheduled", "scheduled - corp"].includes(entry.status.toLowerCase()) && "🔵"} {/* Blue dot for in progress */}
                                                    {entry.status.toLowerCase() === "customer no show" && "❌"}
                                                    {entry.status}
                                                </Box>
                                            </TableCell>

                                            {/* <TableCell>{entry.status}</TableCell> */}
                                            <TableCell>{entry.creator}</TableCell>
                                            <TableCell>{entry.method}</TableCell>
                                            <TableCell>{entry.spoke_with}</TableCell>
                                            <TableCell>{entry.note_content}</TableCell>

                                            <TableCell>{new Date(entry.date).toLocaleString()}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        ) : (
                            <Typography variant="body1" sx={{ mt: 2 }}>
                                Loading check-in history...
                            </Typography>
                        )}
                    </Box>
                </Modal>
            )}

            {/* ObservationModal */}
            <ObservationModal
                isOpen={isObservationModalOpen}
                onClose={closeObservationModal}
                building={building} // Pass building if needed
                refreshData={() => setCheckInHistory(null)} // Refresh data after addition
                id={checkInId} // Pass checkInId to modal
            />
        </>
    );
};

export default FullCheckInHistoryModal;
